module.exports = __webpack_public_path__ + "static/media/group_19_1.39591b36.jpg";